import React, { useEffect, useState } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
// material-ui

function REACHParentDetails() {
  const { logout } = StaffuseAuth();

  const [orders, setOrders] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("Registers_2025", "REACH", setOrders, logout);
  }, []);

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            View REACH Parent Details
          </Typography>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Email
                  </TableCell>

                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Password
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    ContactID
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders.map((Order, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Order?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Order?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.Email}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.Password}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.ContactID}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default REACHParentDetails;
